import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-breadcrumbs',
	templateUrl:'./WaBreadcrumbsPage.html',
	styles: [],
	styleUrls:['./WaBreadcrumbsPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaBreadcrumbsPage
{
	mdContent_282 = `\`\`\`java
import com.jwebmp.webawesome.components.breadcrumb.WaBreadcrumbs;
\`\`\``;
	mdContent_283 = `\`\`\`java
var crumbs = new WaBreadcrumbs<>();
crumbs.add(new WaBreadcrumbItem<>("/home", "Home"));
crumbs.add(new WaBreadcrumbItem<>("/products", "Products"));
crumbs.add(new WaBreadcrumbItem<>(null, "Widget"));
\`\`\``;
}
